/**
 * Path words of the API that are kept literally in a request `kind`; every other
 * segment (UUIDs, numbers, project names, …) becomes `:x`. Kept complete by
 * `activity-route-kind.spec.ts`, which scans the services' URLs.
 */
export const ACTIVITY_ROUTE_WORDS: ReadonlySet<string> = new Set([
  'tasks', 'features', 'markup-drafts', 'markup-tasks', 'missing-segments', 'inspection-items', 'response',
  'staged-edits', 'quick-edit-drafts', 'quick-edit', 'inspection-groups', 'claim', 'answer', 'release', 'undo',
  'start', 'submit', 'complete', 'cancel', 'leave-review', 'request-fixes', 'settings', 'colors', 'map-layers',
  'road-segments', 'projects', 'versions', 'deletion-preview', 'deletion-jobs', 'active', 'ingest', 'upload-url',
  's3', 's3-sources', 'tiles', 'users', 'me', 'roles', 'reset-password', 'inspections', 'import', 'export',
  'stats', 'follow-up-tasks', 'supervisor', 'editors', 'groups', 'group-answers', 'daily', 'summary',
  'overview', 'activity', 'events', 'time', 'time-use', 'curve', 'suggested-connectors', 'editor',
])

const MAX_LEN = 64

/**
 * `"PUT /tasks/:x/markup-drafts"` for an API request; `null` for anything that is
 * not under `apiUrl` (version.json, CDN images, …). Query string and origin dropped.
 */
export function requestKind(method: string, url: string, apiUrl: string): string | null {
  if (!apiUrl || !url.startsWith(apiUrl)) return null
  const path = url.slice(apiUrl.length).split(/[?#]/)[0]
  const segments = path.split('/').filter(s => s.length > 0)
  const templ = segments.map(s => (ACTIVITY_ROUTE_WORDS.has(s) ? s : ':x'))
  return `${method.toUpperCase()} /${templ.join('/')}`.slice(0, MAX_LEN)
}
